import isNil from 'lodash/fp/isNil';
import isNull from 'lodash/fp/isNull';
import last from 'lodash/fp/last';
import { FormattedMessage } from 'react-intl';
import { Unit } from '../../../common/constants';
import { getBatteryLevelPercentage } from '../../../common/tourUtils';
import { convertISOToRelativeDate, getBatteryColor, getBatteryIcon } from '../../../common/utils';
import { RangeStatusIcon } from '../../../components/RangeStatusIcon/RangeStatusIcon';
import { useAppSelector } from '../../../configuration/setup/hooks';
import { selectOrderedWaypoints } from '../../../store/search/searchSelectors';
import { selectItineraries, selectSelectedItinerary } from '../../../store/tour/tourSelectors';
import { selectLocale } from '../../../store/lang/langSelectors';
import { selectBatteryCapacity } from '../../../store/vehicleProfile/vehicleProfileSelectors';

export const ArrivalPanel = () => {
    const waypoints = useAppSelector(selectOrderedWaypoints);
    const selectedItinerary = useAppSelector(selectSelectedItinerary);
    const itineraries = useAppSelector(selectItineraries);
    const locale = useAppSelector(selectLocale);
    const batteryCapacity = useAppSelector(selectBatteryCapacity).value;

    const arrivalWaypoint = last(waypoints);
    const isWaypointInRange = arrivalWaypoint?.isInRange;
    const currentItinerary = selectedItinerary !== undefined ? itineraries?.at(selectedItinerary) : undefined;
    const arrivalSection = last(currentItinerary?.sections);

    const arrivalTime = arrivalSection?.arrivalTime;
    const date = convertISOToRelativeDate(locale, arrivalTime);
    const batteryPct = getBatteryLevelPercentage(batteryCapacity, arrivalSection?.evBatteryCapacityArrival);

    return (
        <li className='timeline-element' data-testid='timeline-element'>
            <div className='timeline-date margin-right-10'>
                <div className='border border-width-3 border-color-white'>
                    <span className='badge badge-lg badge-muted padding-5'>
                        <span className='rioglyph rioglyph-finish' />
                    </span>
                </div>
            </div>
            <div className='timeline-content margin-bottom-15'>
                <div className='text-medium text-size-16 text-color-darker margin-top-5 margin-bottom-5'>
                    <span className='margin-right-5'>
                        <FormattedMessage id='intl-msg:smartRoute.tour.arrival' />
                    </span>
                    {!isNull(isWaypointInRange) && (
                        <RangeStatusIcon isWaypointInRange={isWaypointInRange ?? false} badgeSize='badge-sm' />
                    )}
                </div>
                <div className='display-flex flex-column gap-2'>
                    {date && (
                        <div>
                            <span className='rioglyph rioglyph-calendar text-color-gray margin-right-5' />
                            <span>{date}</span>
                        </div>
                    )}
                    <div>
                        <span className='rioglyph rioglyph-map-marker text-color-gray margin-right-5' />
                        <span>{arrivalWaypoint?.addressLabel}</span>
                    </div>
                </div>
                {!isNil(batteryPct) && (
                    <div className={`${getBatteryColor(batteryPct)}`}>
                        <span className={`${getBatteryIcon(batteryPct)} margin-right-5`} />
                        <span>{batteryPct}</span>
                        <span>&nbsp;{Unit.pct}</span>
                    </div>
                )}
            </div>
        </li>
    );
};
